import { realtimeDb, firestoreDb, firebaseAuth } from '../config/constants'
import firebase from 'firebase';
import log from '../helpers/logger'

export function getMagazineList(){

  let dataList = []
  return firestoreDb.collection("magazine").get().then(function(querySnapshot) {
    let count = 0;
    querySnapshot.forEach(function(doc) {
        log.debug(doc.id, " => ", doc.data());
        dataList.push(doc)
        count = count+1
        if(count === querySnapshot.size){
          return dataList
        }
    });
  }).then(() => dataList);
}

export function updateMagazine (id, magazine) {
  return firestoreDb.collection("magazine").doc(id).update({

    magazine_uuid: magazine.magazine_uuid,
    publisher_id: magazine.publisher_id,
    owner_id: magazine.owner_id,
    tag: magazine.tag,
    title: magazine.title,
    description: magazine.description,
    latest_issue_id: magazine.latest_issue_id,
    is_publish: magazine.is_publish,
    sort_order: magazine.sort_order,
    share_text: magazine.share_text,
    embed_html: magazine.embed_html,
    date_created: magazine.date_created,
    status: magazine.status,
    }).then(() => magazine)
}

export function getMagazine (id) {

  return firestoreDb.collection("magazine").doc(id).get().then(function(doc) {
    if (doc.exists) {
        return doc.data();
    } else {
        return null
    }
  });

}

export function deleteMagazine (id) {
  let magazine = null
  return firestoreDb.collection("magazine").doc(id).update({
    status: 'D'
    }).then(() => magazine)
}

export function createMagazine (magazine) {
  //setup date_created from firebase server.
  magazine.date_created = firebase.firestore.FieldValue.serverTimestamp()

  return firestoreDb.collection("magazine").add({

    magazine_uuid: magazine.magazine_uuid,
    publisher_id: magazine.publisher_id,
    owner_id: magazine.owner_id,
    tag: magazine.tag,
    title: magazine.title,
    description: magazine.description,
    latest_issue_id: magazine.latest_issue_id,
    is_publish: magazine.is_publish,
    sort_order: magazine.sort_order,
    share_text: magazine.share_text,
    embed_html: magazine.embed_html,
    date_created: magazine.date_created,
    status: magazine.status,
    }).then(() => magazine)

}



// WEBPACK FOOTER //
// ./src/services/MagazineService.js